<template>
    <div>
        <div v-if="loading">
            <SpinnerWrapper>
                <Spinner/>
            </SpinnerWrapper>
        </div>
        <div v-for="(faq, i) in faqs">
            <FAQCard :id="faq.id" :question="faq.question" :answer="faq.answer" :open="faq.open" @click="navToFAQ(faq)" @nav="navigate"></FAQCard>
        </div>
    </div>
</template>

<script>
    import FAQCard from "./FAQCard";
    import SpinnerWrapper from "../../utils/SpinnerWrapper";
    import faq from "../../../api/faq"

    export default {
        name: "FAQList",
        components: {SpinnerWrapper, FAQCard},
        data() {
            return {
                id: null,
                faqs: [],
                loading: false
            }
        },
        mounted() {
            this.id = this.$route.params.categoryId;
            this.initView();
        },
        methods: {
            async initView() {
                this.loading = true;
                await this.fetchFAQs();
                if (this.faqs.length === 0) {
                    return this.$router.push({
                        name: "categoryOverview"
                    });
                }
            },

            async fetchFAQs() {
                try {
                    const body = await faq.loadFAQs(this.id);
                    this.faqs = body.faqs.sort((a, b) => {
                        if (a.sortIndex > b.sortIndex) return 1;
                        else return -1;
                    }).map(faq => {
                        faq.open = faq.id === parseInt(this.$route.params.faqId);
                        return faq;
                    });
                    this.loading = false;
                } catch (e) {
                    this.$router.push({
                        name: "categoryOverview"
                    });
                } finally {
                    this.loading = false;
                }
            },
            navToFAQ(faq) {
                if (faq.id !== parseInt(this.$route.params.faqId)) {
                    this.$communicator.trackEvent("click", "FAQPageQuestion", faq.id);
                    this.$router.replace({
                        name: "faq_list",
                        params: {
                            categoryId: this.id,
                            faqId: faq.id
                        }
                    });
                } else {
                    faq.open = !faq.open;
                }
            },
            openFAQ(openFAQId) {
                this.faqs = this.faqs.map(faq => {
                    faq.open = faq.id === parseInt(openFAQId);
                    return faq;
                });
            },
            navigate(url) {
                if (url.indexOf(`/category/${this.id}/faq`) > -1) {
                    return this.$router.replace(new URL(url).pathname);
                }
                const routeData = this.$router.matcher.match(new URL(url).pathname);
                this.id = routeData.params.categoryId;
                this.initView();
                return this.$router.push(new URL(url).pathname);
            }
        },
        beforeRouteEnter(to, from, next) {
            let track = false;
            if (to.params.faqId) {
                track = true;
            }
            next(vm => {
                if (track) {
                    vm.$communicator.trackEvent("click", "FAQPageQuestion", to.params.faqId);
                }
            });
        },
        beforeRouteUpdate(to, from, next) {
            if (from.params.categoryId !== to.params.categoryId) {
                this.id = to.params.categoryId;
                this.initView();
            } else {
                this.openFAQ(to.params.faqId);
            }
            next();
        }
    }
</script>

<style lang="scss" scoped>

</style>
